import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border-t border-gray-200 mt-6 pt-6 space-y-4" }
const _hoisted_2 = { class: "text-lg font-semibold text-gray-700" }
const _hoisted_3 = { class: "text-sm text-gray-500" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_5 = { class: "input-form-label" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-form-label" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "input-form-label" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "input-form-label" }
const _hoisted_13 = { class: "input-form-label" }
const _hoisted_14 = { value: null }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "text-xs text-gray-500 mt-1" }

import { computed } from "vue";
import Multiselect from "@vueform/multiselect";
import { EEntityScope } from "@/types/common/entityApproval/EntityApproval";
import { IScopeFields } from "@/types/common/entityApproval/EntityScope";
import { useCoordinatorOptions } from "@/composables/useCoordinatorOptions";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    directorateOptions: null
  },
  setup(__props: any, { emit }: { emit: ({
  "update:modelValue": [value: IScopeFields];
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: IScopeFields;
  directorateOptions?: Array<{ id: string; name: string }>;
}

const scopeEnum = EEntityScope;





const { coordinators } = useCoordinatorOptions();

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const directorateOptions = computed(() => props.directorateOptions ?? []);

const scopeOptions = [
  { value: EEntityScope.PRIVATE, label: t("entityScope.private") },
  { value: EEntityScope.UNIT, label: t("entityScope.unit") },
  { value: EEntityScope.MULTI_UNIT, label: t("entityScope.multiUnit") },
  { value: EEntityScope.ALL, label: t("entityScope.all") },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("entityScope.title")), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("entityScope.hint")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)("entityScope.viewScope")), 1),
        _withDirectives(_createElementVNode("select", {
          class: "input-form w-full",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).viewScope) = $event))
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scopeOptions, (opt) => {
            return _createElementVNode("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_6)
          }), 64))
        ], 512), [
          [_vModelSelect, _unref(model).viewScope]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("entityScope.editScope")), 1),
        _withDirectives(_createElementVNode("select", {
          class: "input-form w-full",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).editScope) = $event))
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scopeOptions, (opt) => {
            return _createElementVNode("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_8)
          }), 64))
        ], 512), [
          [_vModelSelect, _unref(model).editScope]
        ])
      ])
    ]),
    (_unref(model).viewScope === _unref(scopeEnum).MULTI_UNIT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)("entityScope.viewDirectorates")), 1),
          _createVNode(_unref(Multiselect), {
            modelValue: _unref(model).viewDirectorateIds,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).viewDirectorateIds) = $event)),
            options: _unref(directorateOptions),
            mode: "multiple",
            "value-prop": "id",
            label: "name",
            placeholder: _unref(t)('entityScope.selectDirectorates')
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    (_unref(model).editScope === _unref(scopeEnum).MULTI_UNIT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)("entityScope.editDirectorates")), 1),
          _createVNode(_unref(Multiselect), {
            modelValue: _unref(model).editDirectorateIds,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).editDirectorateIds) = $event)),
            options: _unref(directorateOptions),
            mode: "multiple",
            "value-prop": "id",
            label: "name",
            placeholder: _unref(t)('entityScope.selectDirectorates')
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("entityScope.coordinator")), 1),
      _withDirectives(_createElementVNode("select", {
        class: "input-form w-full",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).coordinatorId) = $event))
      }, [
        _createElementVNode("option", _hoisted_14, _toDisplayString(_unref(t)("entityScope.coordinatorAny")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coordinators), (user) => {
          return (_openBlock(), _createElementBlock("option", {
            key: user.id,
            value: user.id
          }, _toDisplayString(user.fullName || `${user.surname || ""} ${user.name || ""}`.trim()), 9, _hoisted_15))
        }), 128))
      ], 512), [
        [_vModelSelect, _unref(model).coordinatorId]
      ]),
      _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("entityScope.coordinatorHint")), 1)
    ])
  ]))
}
}

})